module.exports = __webpack_public_path__ + "media/react/gre/adaptive_prep_v2/assets/illustrations/study_day_complete-839058886f822d211cab80ed5a58d78f.svg";